import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getAllDescriptionTags = async (testSuiteResultId) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No User details found in localStorage");

  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getAllDescriptionTagsForSuiteResult&companyid=${user.companyid}&testSuiteResultId=${testSuiteResultId}`,
  );
  return response.data;
};

const useGetAllDescriptionTags = (testSuiteResultId, options) => {
  return useQuery({
    queryKey: ["allDescriptionTags", testSuiteResultId],
    queryFn: () => getAllDescriptionTags(testSuiteResultId),
    enabled: options.enabled,
    ...options,
  });
};

export default useGetAllDescriptionTags;
